import request from '@/utils/request'

export function tbSysPersonnelQuery(data) { //人员管理 - 查询
    return request({
        method: 'get',
        url: 'tbSysUser/query',
        params: data
    })
}

export function tbSysPersonnelVerify(data) { //角色管理 - 新增-账号验证
    return request({
        method: 'post',
        url: '/tbSysUser/verifyByUser',
        data
    })
}

export function tbSysPersonnelAdd(data) { //角色管理 - 新增
    return request({
        method: 'post',
        url: '/tbSysUser/add',
        data
    })
}

export function tbSysPersonnelUpdate(data) { //角色管理 - 编辑
    return request({
        method: 'post',
        url: '/tbSysUser/update',
        data
    })
}

export function tbSysPersonnelDelete(data) { //角色管理 - 删除
    return request({
        method: 'post',
        url: 'tbSysUser/delete',
        data
    })
}

export function tbSysPersonnelUpdatePassword(data) { //角色管理 - 重置账号密码
    return request({
        method: 'post',
        url: 'tbSysUser/updatePassword',
        data
    })
}

export function tbSysPersonnelUpdateUserRole(data) { //角色管理 - 角色配置
    return request({
        method: 'post',
        url: 'tbSysUser/updateUserRole',
        data
    })
}

export function tbSysPersonnelTempDownload(data) { //角色管理 - 模板下载
    return request({
        method: 'get',
        url: 'tbSysUser/down',
        params: data
    })
}

export function tbSysPersonnelBatchImport(data) { //角色管理 - 批量导入
    return request({
        method: 'post',
        url: 'tbSysUser/import',
        data
    })
}

